var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapOutlinedWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "map",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 18,
    height: 18,
    fill: "#333"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_30",
    "data-name": "Rectangle 30",
    width: 24,
    height: 24,
    fill: "#334856",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1932",
    "data-name": "Groupe 1932",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1931",
    "data-name": "Groupe 1931",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_626",
    "data-name": "Trac\\xE9 626",
    d: "M17.5,0l-.16.03L12,2.1,6,0,.36,1.9A.5.5,0,0,0,0,2.38V17.5a.5.5,0,0,0,.5.5l.16-.03L6,15.9,12,18l5.64-1.9a.5.5,0,0,0,.36-.48V.5a.5.5,0,0,0-.5-.5M7,2.47l4,1.4V15.53l-4-1.4ZM2,3.46,5,2.45v11.7L2,15.31ZM16,14.54l-3,1.01V3.86L16,2.7Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapOutlinedWhite);
export default __webpack_public_path__ + "static/media/MapOutlinedWhite.5932cd6830cf01c35e6a334fe2bb0062.svg";
export { ForwardRef as ReactComponent };